<script lang="ts">
  import { fade } from 'svelte/transition';

  let {
    messages = [],
    rotateInterval = 8000,
    fadeDuration = 2000,
  }: { messages?: string[]; rotateInterval?: number; fadeDuration?: number } = $props();

  let shuffledMessages: string[] = $state([]);
  let messageIndex: number = $state(0);
  let currentMessage = $derived(shuffledMessages[messageIndex] ?? '');
  let fadeDurationHalf = $derived(fadeDuration / 2);

  $effect(() => {
    const items = messages;
    if (items.length === 0) {
      shuffledMessages = [];
      return;
    }

    const arr = [...items];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j]!, arr[i]!];
    }
    shuffledMessages = arr;
    messageIndex = 0;

    if (arr.length <= 1) return;

    let idx = 0;
    const timer = setInterval(() => {
      idx = (idx + 1) % arr.length;
      messageIndex = idx;
    }, rotateInterval);

    return () => clearInterval(timer);
  });
</script>

<div class="message-area relative mt-3 flex justify-center">
  {#if shuffledMessages.length > 0}
    {#key currentMessage}
      <div
        class="absolute rounded-sm bg-prim p-3 text-center"
        in:fade={{ duration: fadeDuration }}
        out:fade={{ duration: fadeDurationHalf, delay: fadeDuration }}
      >
        <span
          class="text-muted-foreground text-sm"
          in:fade={{
            duration: fadeDurationHalf,
            delay: fadeDurationHalf,
          }}
          out:fade={{ duration: fadeDurationHalf }}
        >
          {currentMessage}
        </span>
      </div>
    {/key}
  {/if}
</div>

<style>
  .message-area {
    min-height: 1.5em;
  }
</style>
